<template>
    <div class="flex justify-around">
        <div class="vx-row">
            <vs-card>
                <template #title>
                    <h3 class="justify-around flex">STB App installation</h3>
                </template>
                <template #text>
                    <div class="p-6">
                        <vs-input label="IP" class="mt-6" v-model="ip" @keyup.enter="installApp">
                            <template #icon>
                                <font-awesome-icon icon="network-wired"/>
                            </template>
                        </vs-input>

                        <vs-button class="mt-6" color="success" @click="installApp">Install APP</vs-button>
                        <vs-button class="mt-6" color="danger" @click="removeApp">Remove APP</vs-button>
                    </div>
                </template>
            </vs-card>
        </div>

        <vs-dialog width="550px" not-center blur v-model="warningPromptActive">
            <template #header>
                <h4 class="not-margin">
                    There was an error installing APP
                </h4>
            </template>


            <div class="con-content">
                <p style="white-space:pre">
                    {{errorText}}
                </p>
            </div>

            <template #footer>
                <div class="con-footer">
                    <vs-button @click="warningPromptActive=false" transparent>
                        Close
                    </vs-button>
                </div>
            </template>
        </vs-dialog>

        <vs-dialog width="550px" not-center blur v-model="appInstalledPrompt">
            <template #header>
                <h4 class="not-margin">
                    APP Installed
                </h4>
            </template>


            <div class="con-content">
                <p style="white-space:pre">
                    APP was installed successfully!
                </p>
            </div>

            <template #footer>
                <div class="con-footer">
                    <vs-button @click="appInstalledPrompt=false" transparent>
                        Close
                    </vs-button>
                </div>
            </template>
        </vs-dialog>

        <vs-dialog width="550px" not-center blur v-model="appRemovedPrompt">
            <template #header>
                <h4 class="not-margin">
                    APP Removed
                </h4>
            </template>


            <div class="con-content">
                <p style="white-space:pre">
                    APP was removed successfully!
                </p>
            </div>

            <template #footer>
                <div class="con-footer">
                    <vs-button @click="appRemovedPrompt=false" transparent>
                        Close
                    </vs-button>
                </div>
            </template>
        </vs-dialog>

    </div>
</template>

<script>

    export default {
        name: 'Home',
        data() {
            return {
                ip: '',
                errorText: 'This is an error\n this is new line',
                warningPromptActive: false,
                appInstalledPrompt: false,
                appRemovedPrompt: false
            }
        },
        methods: {
            installApp() {
                const loading = this.$vs.loading({
                    type: 'circles'
                })
                const thisIns = this
                const installPromise = this.$http.post('/install', {
                    ip: this.ip
                })
                installPromise.then(function() {
                    thisIns.appInstalledPrompt = true
                }).catch(function(error) {
                    thisIns.errorText = error.response.data
                    thisIns.warningPromptActive = true
                }).finally(function() {
                    loading.close()
                })
            },
            removeApp() {
                const loading = this.$vs.loading({
                    type: 'circles'
                })
                const thisIns = this
                const installPromise = this.$http.post('/remove', {
                    ip: this.ip
                })
                installPromise.then(function() {
                    thisIns.appRemovedPrompt = true
                }).catch(function(error) {
                    thisIns.errorText = error.response.data
                    thisIns.warningPromptActive = true
                }).finally(function() {
                    loading.close()
                })
            }
        },
        watch: {
            warningPromptActive() {
                if (!this.warningPromptActive) {
                    this.errorText = ''
                }
            }
        }
    }
</script>
